import React, { Component } from "react";
import { Layout } from "antd";
import { withRouter } from "react-router-dom";
import routes from "../../routes/config";
import Menus from "./Menus";
import bus from "@utils/bus";
import { getCurrentEnvironment, filterPermission } from "@utils/tool";
import { notify } from "@api/recommendGame";

const { Sider } = Layout;

class SiderMenu extends Component {
    static setMenuOpen = props => {
        const { pathname } = props.location;

        return {
            openKey: pathname.substr(0, pathname.lastIndexOf("/")),
            selectedKey: pathname
        };
    };

    state = {
        collapsed: false,
        mode: "inline",
        openKey: "",
        selectedKey: "",
        firstHide: true, // 点击收缩菜单，第一次隐藏展开子菜单，openMenu时恢复
        collapsedWidth: 64,
        permissionMenus: []
    };

    componentWillMount() {
        const isPhone = getCurrentEnvironment() === "phone";
        const tempState = SiderMenu.setMenuOpen(this.props);

        this.setState({
            collapsed: isPhone ? true : false,
            collapsedWidth: isPhone ? 0 : 64,
            firstHide: tempState.openKey.length > 0 ? false : true,
            openKey: tempState.openKey,
            selectedKey: tempState.selectedKey
        });
        bus.subscribe("menuToggle", this.handleToggleMenu.bind(this));
        bus.subscribe("menuRedirect", this.handleMenuRedirect.bind(this));
        bus.subscribe("clearBadge", this.clearBadge);

        this.initData();
    }

    componentDidMount() {
        if (bus.userInfo) {
            const perCodes = bus.userInfo.perCodes || [];

            if (perCodes.includes("*") || perCodes.includes("recommend_game")) {
                this.updateMenu();
            }
        } else {
            this.props.history.push('/login');
        }
    }

    componentWillUnmount() {
        bus.unSubscribe(["menuToggle", "menuRedirect"]);
    }

    handleMenuRedirect(data) {
        setTimeout(() => {
            this.setState({ selectedKey: data });
        }, 100);
    }

    handleToggleMenu() {
        this.setState({ collapsed: !this.state.collapsed });
    }

    menuClick = e => {
        this.setState({ selectedKey: e.key });
    };

    openMenu = item => {
        this.setState({
            openKey: item[item.length - 1],
            firstHide: false
        });
    };

    clearBadge = () => {
        const { permissionMenus } = this.state;

        permissionMenus.forEach(item => {
            if (item.permissionName === "recommend_game") {
                item.badgeCount = 0;
            }
        });

        this.setState({ permissionMenus });
    };

    updateMenu = async () => {
        const res = await notify();
        const { permissionMenus } = this.state;
        const isRecommendgame =
            this.props.history.location.pathname.indexOf("recommendgame") !==
            -1;

        if (
            res.data.meta.errCode !== 0 ||
            isRecommendgame ||
            res.data.data.unreadNum < 1
        ) {
            return;
        }

        permissionMenus.forEach(item => {
            if (item.permissionName === "recommend_game") {
                item.badgeCount = res.data.data.unreadNum;
            }
        });

        this.setState({ permissionMenus });
    };

    initData = () => {
        const tempMe = bus.me
            ? bus.me.data.accountInfo && bus.me.data.accountInfo.perCodes
            : [];
        const permissionMenus = filterPermission(routes.menus, tempMe);

        this.setState({ permissionMenus });
    };

    render() {
        const { permissionMenus } = this.state;

        return (
            <Sider
                trigger={null}
                breakpoint="lg"
                collapsible
                style={{ overflowY: "auto", height: "100vh" }}
                collapsed={this.state.collapsed}
                collapsedWidth={this.state.collapsedWidth}
            >
                <div className="logo">
                    <img
                        src={require("../../assets/Images/logo.jpg")}
                        alt="logo"
                    />
                    {this.state.collapsed ? "" : <span>渠道商户后台</span>}
                </div>
                <Menus
                    theme="dark"
                    menus={permissionMenus}
                    onClick={this.menuClick}
                    mode="inline"
                    selectedKeys={[this.state.selectedKey]}
                    // defaultSelectedKeys={[this.state.selectedKey]}
                    openKeys={
                        this.state.firstHide ? null : [this.state.openKey]
                    }
                    // defaultOpenKeys={this.state.firstHide ? null : [this.state.openKey]}
                    onOpenChange={this.openMenu}
                />
            </Sider>
        );
    }
}

export default withRouter(SiderMenu);
